/**
 * Formats a date string for approval messages
 * @param dateString - ISO date string
 * @returns Formatted date string like "8/12/2025 at 9:32:41 a.m. PST" or "8/12/2025 at 9:32:41 a.m. PDT" (in browser timezone)
 */
export function formatApprovalDate(dateString: string): string {
  const date = new Date(dateString);

  // Format: M/D/YYYY at H:MM:SS a.m. [timezone] (using browser timezone)
  const options: Intl.DateTimeFormatOptions = {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  };

  const formatted = date.toLocaleString('en-US', options);

  return formatted
    .replace(/\bAM\b/g, 'a.m.')
    .replace(/\bPM\b/g, 'p.m.')
    .replace(/,/g, ' at');
}

/**
 * Formats a date string for rejection messages
 * @param dateString - ISO date string
 * @returns Formatted date string like "8/12/2025 at 9:32:41 a.m. PST" or "8/12/2025 at 9:32:41 a.m. PDT" (in browser timezone)
 */
export function formatRejectionDate(dateString: string): string {
  const date = new Date(dateString);

  // Format: M/D/YYYY at H:MM:SS a.m. [timezone] (using browser timezone)
  const options: Intl.DateTimeFormatOptions = {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  };

  const formatted = date.toLocaleString('en-US', options);

  return formatted
    .replace(/\bAM\b/g, 'a.m.')
    .replace(/\bPM\b/g, 'p.m.')
    .replace(/,/g, ' at');
}
